import Vue from 'vue';
import DataTable from './components/DataTable';

Vue.component('accordion-item', () => import('@/components/contentElements/AccordionItem'));
Vue.component('app-container', () => import('@/components/AppContainer'));
Vue.component('app-header', () => import('@/components/AppHeader'));
Vue.component('app-nav-bar', () => import('@/components/AppNavBar'));
Vue.component('app-navigation', () => import('@/components/AppNavigation'));
Vue.component('base-button', () => import('@/components/BaseButton'));
Vue.component('base-datetime', () => import('@/components/BaseDateTime'));
Vue.component('base-dialog', () => import('@/components/BaseDialog'));
Vue.component('base-heading', () => import('@/components/contentElements/BaseHeading'));
Vue.component('base-link', () => import('@/components/contentElements/BaseLink'));
Vue.component('base-iframe', () => import('@/components/contentElements/BaseIframe'));
Vue.component('app-link-block', () => import('@/components/contentElements/TheAppLinkBlock'));
Vue.component('base-row', () => import('@/components/contentElements/BaseRow'));
Vue.component('base-tooltip', () => import('@/components/BaseTooltip'));
Vue.component('callout', () => import('@/components/contentElements/Callout'));
Vue.component('datepicker', () => import('vuejs-datepicker'));
Vue.component('document-meta', () => import('@/components/DocumentMeta'));
Vue.component('file-icon', () => import('@/components/FileIcon'));
Vue.component('filter-bar', () => import('@/components/FilterBar'));
Vue.component('form-datepicker', () => import('@/components/FormDatepicker'));
Vue.component('form-field', () => import('@/components/FormField'));
Vue.component('form-label', () => import('@/components/FormLabel'));
Vue.component('form-multiselect', () => import('@/components/FormMultiselect'));
Vue.component('form-resource', () => import('@/components/FormResource'));
Vue.component('form-options', () => import('@/components/FormOptions'));
Vue.component('form-gallery', () => import('@/components/FormGallery'));
Vue.component('form-survey', () => import('@/components/FormSurvey'));
Vue.component('form-poll', () => import('@/components/FormPoll'));
Vue.component('hero-slider', () => import('@/components/HeroSlider'));
Vue.component('inline-svg', () => import('@/components/InlineSvg'));
Vue.component('loading', () => import('@/components/Loading'));
Vue.component('media-gallery', () => import('@/components/contentElements/MediaGallery'));
Vue.component('media-image', () => import('@/components/contentElements/MediaImage'));
Vue.component('media-video', () => import('@/components/contentElements/MediaVideo'));
Vue.component('media-resource', () => import('@/components/contentElements/MediaResource'));
Vue.component('media-eform', () => import('@/components/contentElements/MediaEform'));
Vue.component('media-survey', () => import('@/components/contentElements/MediaSurvey'));
Vue.component('media-file', () => import('@/components/contentElements/MediaFile'));
Vue.component('media-file-upload', () => import('@/components/contentElements/MediaFileUpload'));
Vue.component('message', () => import('@/components/Message'));
Vue.component('modal', () => import('@/components/Modal'));
Vue.component('multiselect', () => import('vue-multiselect'));
Vue.component('page-title', () => import('@/components/PageTitle'));
Vue.component('resource-list', () => import('@/components/contentElements/ResourceList'));
Vue.component('section-block', () => import('@/components/SectionBlock'));
Vue.component('side-panel-inner', () => import('@/components/SidePanelInner'));
Vue.component('side-panel', () => import('@/components/SidePanel'));
Vue.component('spacer', () => import('@/components/Spacer'));
Vue.component('tabs-item', () => import('@/components/TabsItem'));
Vue.component('tabs', () => import('@/components/Tabs'));
Vue.component('text-block', () => import('@/components/contentElements/TextBlock'));
Vue.component('vuetable', () => import('vuetable-2'));

// form builder
Vue.component('form-textfield', () => import('@/components/FormBuilder/FormTextfield.vue'));
Vue.component('form-dateinput', () => import('@/components/FormBuilder/FormDateinput.vue'));
Vue.component('form-select', () => import('@/components/FormBuilder/FormSelect.vue'));
Vue.component('form-checkbox', () => import('@/components/FormBuilder/FormCheckbox.vue'));
Vue.component('form-textarea', () => import('@/components/FormBuilder/FormTextarea.vue'));
Vue.component('form-radio', () => import('@/components/FormBuilder/FormRadio.vue'));
